import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
/**
 * @todo 登入檢查
 */
const LoginCheck = (): Promise<boolean> => {
    const url = RouteUrlList.API_CheckIfLogin.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.false, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, {}, config)
        .then((res: AxiosResponse<GeneralResp>) => {
            return res.data.status;
        })
        .catch((e) => {
            return false;
        });
};

export default LoginCheck;
